import styled from 'styled-components'

export const EditLink = styled.a`
  :focus {
    border-bottom: 1px solid;
  }

  :hover {
    border-bottom: 1px solid;
  }
`

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  width: calc(100vw - 64px);
  align-items: space-between;
  align: center;
`
